export default "__VITE_ASSET__b9c286ed__"